export const additionalInfoActions = {
  handlePropertyManagerNotified: ({ commit }: { commit: Function }, payload: boolean) => {
    commit("setPropertyManagerNotified", payload);
  },
  handleDiscoveredLoss: ({ commit }: { commit: Function }, payload: string) => {
    commit("setDiscoveredLoss", payload);
  },
  handleCurrentLocationDamagedItems: ({ commit }: { commit: Function }, payload: string) => {
    commit("setCurrentLocationDamagedItems", payload);
  },
  handleFiledOtherClaim: ({ commit }: { commit: Function }, payload: boolean) => {
    commit("setFiledOtherClaim", payload);
  },
  handleFiledOtherClaimLossType: ({ commit }: { commit: Function }, payload: string) => {
    commit("setFiledOtherClaimLossType", payload);
  },
  handleFiledOtherClaimDate: ({ commit }: { commit: Function }, payload: string) => {
    commit("setFiledOtherClaimDate", payload);
  }
};
